import { IConfigsType } from '../../types'

const demo: IConfigsType = {
  dh_wb: {
    '/:brand/product': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'dh/product',
      },
      chatbox: {
        type: 'chatbox-v2',
        agentCode: 'product-mix',
        sendStoreId: false,
        hideFromNonExpoUsers: false,
      },
    },
  },
}

export default demo
